module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/revisedpropertyregister/revisedpropertyregister.component.css
// module id = ./src/app/planning/revisedpropertyregister/revisedpropertyregister.component.css
// module chunks = main